import { useQuery, UseQueryResult } from 'react-query';
import type { ResponseFormat } from '../algebra/global';

import { Http } from '../prelude/http';

export interface IAnnouncements {
  id: string;
  app_id: string;
  message: string;
  start_time: number;
  end_time: number;
  createdAt: number;
  updatedAt: number;
}

export const useAnnouncement = (): UseQueryResult<Array<IAnnouncements>> => {
  return useQuery(['announcement'], () => Http.Request<ResponseFormat<Array<IAnnouncements>>>('GET', `/hotlines/api/v1/announcement.get-active-announcements`).then((res) => res.data));
};
